import React, { useEffect, useRef, useState } from 'react';
import { DotsMenu, CameraRotation } from '@myinterview/component-library';
import { DeviceSelectorList } from './DeviceSelectorList';
import { mediaDeviceType } from '../interfaces/recorderInterface';
import { isMobile } from '../utils/device.utils';

export interface IDeviceSelectorProps {
  handleDeviceChange: (type?: mediaDeviceType, id?:string) => void;
  audioDevices?: MediaDeviceInfo[];
  videoDevices?: MediaDeviceInfo[];
  selectedAudioDevice?: MediaDeviceInfo;
  selectedVideoDevice?: MediaDeviceInfo;
  myinterviewRef: React.RefObject<HTMLDivElement>;
  recordWithoutVideo?:boolean;
}
export const DeviceSelector = ({
  handleDeviceChange, videoDevices = [], audioDevices = [], selectedAudioDevice, selectedVideoDevice, myinterviewRef, recordWithoutVideo,
}:IDeviceSelectorProps) => {
  const menuRef = useRef<HTMLDivElement>(null);
  const [isSettingsOpen, setSettingsOpen] = useState<boolean>(false);

  useEffect(() => {
    const checkIfClickedOutside = (e:any) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (isSettingsOpen && menuRef.current && !menuRef.current.contains(e.target)) {
        setSettingsOpen(false);
      }
    };

    myinterviewRef?.current?.shadowRoot?.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      myinterviewRef?.current?.shadowRoot?.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isSettingsOpen]);

  return (isMobile && !recordWithoutVideo)
    ? (
      <span className="myinterview-widget-device myinterview-widget-device__mobile" onClick={() => handleDeviceChange()} role="presentation">
        <CameraRotation />
      </span>
    )
    : (
      <div ref={menuRef} className="myinterview-widget-device myinterview-widget-device__desktop">

        <button className="myinterview-widget-device__menu-button" onClick={() => setSettingsOpen((prev) => !prev)} type="button">
          <DotsMenu />
        </button>

        {isSettingsOpen && (
        <div className="myinterview-widget-device__modal">
          <div className="myinterview-widget-device__select-wrapper">

            {!recordWithoutVideo && (
            <DeviceSelectorList
              deviceList={videoDevices}
              selectedDevice={selectedVideoDevice}
              onDeviceSelected={handleDeviceChange}
              deviceType="video"
            />
            )}

            <DeviceSelectorList
              deviceList={audioDevices}
              selectedDevice={selectedAudioDevice}
              onDeviceSelected={handleDeviceChange}
              deviceType="audio"
            />

          </div>
        </div>
        )}
      </div>
    );
};
